<template>
  <div>
    <v-dialog
      v-model="modalIsOpen"
      transition="dialog-bottom-transition"
      fullscreen
    >
      <v-card>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 text-right">
              <v-btn
                @click="modalIsOpen = false"
                class="btn-modern btn-modern-delete"
                ><i class="fas fa-reply mr-2"></i> FECHAR</v-btn
              >
            </div>
            <div class="col-md-12">
              <h1 class="title">
                COMPARAÇÃO DE FATURAMENTO DO MÊS ATUAL COM O MÊS FILTRADO DO(A)
                CLIENTE:
                <strong>{{ item.finance_client_name }}</strong>
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group">
                    <input
                      class="form-control"
                      type="month"
                      v-model="month_filter"
                    />
                    <div class="input-group-pprend">
                      <v-btn
                        :disabled="loading"
                        @click="paginateFilter"
                        class="ml-2 btn-modern btn-modern-save"
                        ><i class="fas fa-filter mr-2"></i> FILTRAR</v-btn
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <CompareBillingTable
                    :data="data_filter"
                    :total="total_filter"
                    :total_gain="total_gain_filter"
                    :total_spent="total_spent_filter"
                    :max_progress="max_progress_filter"
                    :period_result="period_result_filter"
                    :forecast_balance="forecast_balance_filter"
                    :month="month_filter"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-12">
                  <input
                    disabled
                    class="form-control"
                    type="month"
                    :value="moment().format('YYYY-MM')"
                  />
                </div>
                <div class="col-md-12">
                  <CompareBillingTable
                    :data="data"
                    :total="total"
                    :total_gain="total_gain"
                    :total_spent="total_spent"
                    :max_progress="max_progress"
                    :period_result="period_result"
                    :forecast_balance="forecast_balance"
                    :month="month"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-btn
      x-small
      :disabled="loading"
      v-if="item.id && item.finance_client_id"
      class="btn-modern btn-modern-info"
      @click="handleModal"
    >
      <i class="fas fa-not-equal mr-1"></i>
      <i class="fas fa-check"></i>
    </v-btn>
  </div>
</template>

<script>
import CompareBillingTable from "../List/CompareBilling/Table";

import api from "../../../../services/api";

import moment from "moment";

import { getRestHomeSelectedFinancialAccount } from "../../../../lib/functions";

export default {
  name: "CompareBilling",

  components: {
    CompareBillingTable,
  },

  data() {
    return {
      modalIsOpen: false,

      total_spent_filter: 0,
      total_gain_filter: 0,
      total_filter: 0,
      max_progress_filter: 0,
      period_result_filter: 0,
      forecast_balance_filter: 0,
      month_filter: moment().subtract(1, "month").format("YYYY-MM"),
      data_filter: [],

      total_spent: 0,
      total_gain: 0,
      total: 0,
      max_progress: 0,
      period_result: 0,
      forecast_balance: 0,
      month: moment().format("YYYY-MM"),
      data: [],

      loading: false,
    };
  },

  props: {
    item: Object,
    account_ids: Array,
    month_props: String,
  },

  methods: {
    getRestHomeSelectedFinancialAccount,
    moment,

    handleModal() {
      let { item, month_props } = this;

      this.$bvModal.hide(`action-${item.id}`);
      //   this.$bvModal.show(
      //     `compare-billing-${item.finance_launch_bills_to_pay_id}-${item.id}`
      //   );

      this.modalIsOpen = true;

      if (month_props != this.month) {
        this.month_filter = month_props;
      }

      this.paginateFilter();
      this.paginateCurrentMonth();
    },

    async paginateCurrentMonth() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let { account_ids } = this;

        let start_date = moment().startOf("month").format("YYYY-MM-DD");
        let end_date = moment().endOf("month").format("YYYY-MM-DD");

        let page = 1;
        let itemsPerPage = 100;

        let params = {
          rest_home_id_selected_financial_account,
          type: "TODOS",
          cash_competence: "cash",
          month: moment().format("YYYY-MM"),
          dayMonthYear: "month",
          finance_client_ids: [this.item.finance_client_id],
          filter_by_period: false,
          start_date,
          end_date,
          page,
          itemsPerPage,
          account_ids,
          compare_billing: "compare_billing",
        };

        let response = await api.get("/rest-home/financial/launch/list", {
          params,
        });

        let {
          data,
          total_gain,
          total_spent,
          total,
          max_progress,
          period_result,
          forecast_balance,
        } = response.data;

        this.data = data;
        this.total_gain = total_gain;
        this.total_spent = total_spent;
        this.total = total;
        this.max_progress = max_progress;
        this.period_result = period_result;
        this.forecast_balance = forecast_balance;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginateFilter() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let { account_ids, month_filter } = this;

        let start_date = moment(month_filter)
          .startOf("month")
          .format("YYYY-MM-DD");
        let end_date = moment(month_filter).endOf("month").format("YYYY-MM-DD");

        let page = 1;
        let itemsPerPage = 100;

        let params = {
          rest_home_id_selected_financial_account,
          type: "TODOS",
          cash_competence: "cash",
          month: moment(month_filter).format("YYYY-MM"),
          dayMonthYear: "month",
          finance_client_ids: [this.item.finance_client_id],
          filter_by_period: false,
          start_date,
          end_date,
          page,
          itemsPerPage,
          account_ids,
          compare_billing: "compare_billing",
        };

        let response = await api.get("/rest-home/financial/launch/list", {
          params,
        });

        let {
          data,
          total_gain,
          total_spent,
          total,
          max_progress,
          period_result,
          forecast_balance,
        } = response.data;

        this.data_filter = data;
        this.total_gain_filter = total_gain;
        this.total_spent_filter = total_spent;
        this.total_filter = total;
        this.max_progress_filter = max_progress;
        this.period_result_filter = period_result;
        this.forecast_balance_filter = forecast_balance;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
</style>